import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnergyResourceService } from 'src/app/providers/energy-resource/energy-resource.service';

@Component({
  selector: 'app-medical-modal',
  templateUrl: './medical-modal.component.html',
  styleUrls: ['./medical-modal.component.scss']
})
export class MedicalModalComponent implements OnInit {
  @Input() header;
  @Input() empId;
  @Input() medicalId;
  @Input() medicalData;
  medicalForm : FormGroup;
  submitted = false;
  loading = false;
  result: any = [];
  medicals: any;
  medFile: any;
  mapId: any;
  constructor(
    private erService : EnergyResourceService
  ) { }

  ngOnInit(): void {
    this.medicalForm = new FormGroup({
      user_id : new FormControl('' , Validators.required),
      medical_id : new FormControl('' , Validators.required),
      inst_name : new FormControl('' , Validators.required),
      start_date : new FormControl('' , Validators.required),
      valid_date : new FormControl('' , Validators.required),
      attachment : new FormControl(''),
      map_id : new FormControl(''),
    });
    // this.getSiteMedical(this.empId);
    setTimeout(() => {
      this.medicalForm.patchValue({
        medical_id : this.medicalId
      });
    }, 3000);
  }

  // getSiteMedical(empId): void {
  //   this.erService.getSiteMedical(empId).subscribe(res => {
  //     this.result = res;
  //     this.medicals = this.result.data;
  //   });
  // }


  get mediclErrorMsg() {return this.medicalForm.controls}
  onSubmitMedical(): void {
    console.log('medical_id' , this.medicalId)
    console.log('medical_id data' , this.medicalData)
    console.log(this.medicalForm.value)
    this.submitted = true;
    if(this.medicalForm.invalid){
      return
    }
    const medicalFormData = new FormData();
    medicalFormData.append('medical_id', this.medicalForm.get('medical_id').value);
    medicalFormData.append('inst_name', this.medicalForm.get('inst_name').value);
    medicalFormData.append('start_date', this.medicalForm.get('start_date').value);
    medicalFormData.append('valid_date', this.medicalForm.get('valid_date').value);
    medicalFormData.append('user_id', this.medicalForm.get('user_id').value);
    medicalFormData.append('attachment', this.medFile);
    medicalFormData.append('map_id', this.mapId);
  }

  onReset(): void {

  }
  onFileChange(event) : void {
    if(event.target.files.length > 0) {
      const mfile = event.target.files[0];
      this.medFile = mfile;
    }
  }
}
